<template>
    <div class="content d-flex flex-column">
        <transition name="fade" mode="out-in">
            <!-- your content here -->
            <router-view />
        </transition>
    </div>
</template>
<script>
export default {}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s;
}

/* .fade-leave-active in <2.1.8 */
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.content {
    height: 100%;
}
</style>
